import DOMPurify from 'dompurify';

export const sanitizeText = (text: string | undefined): string => {
	if (!text) return '';
	return DOMPurify.sanitize(text, { ALLOWED_TAGS: [] });
};